import { CardStatus } from '../types';

const getCardAvailableStatuses = (status: CardStatus) => {
  const statuses = [];

  if (status === CardStatus.NEW) {
    statuses.push({ name: 'Process card', value: CardStatus.ORDERED });
  }

  if (status === CardStatus.ORDERED || status === CardStatus.FROZEN) {
    statuses.push(
      {
        name: 'Activate card',
        value: CardStatus.ACTIVE,
      },
      {
        name: 'Cancel card',
        value: CardStatus.CANCELED,
      },
    );
  }

  if (status === CardStatus.ACTIVE) {
    statuses.push({ name: 'Freeze card', value: CardStatus.FROZEN });
  }

  if (status === CardStatus.CANCELED) {
    statuses.push({ name: 'Approve card', value: CardStatus.ACTIVE });
  }

  return statuses;
};

export default getCardAvailableStatuses;
